
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricAggregated} from "@/cube/metric-data"
import SuperScoreStar from "@avantek/commons-js/superscore/SuperScoreStar/SuperScoreStar.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"
import anime from "animejs"

@Component({components: {ChangeRateWidget, SuperScoreStar: <any>SuperScoreStar}})
export default class SuperScoreStarComponentWidget extends Vue {
  @Prop() metricData: MetricAggregated
  @Prop() name: SuperScoreArea
  @Prop() to: string

  animatedScore = 0

  mounted() {
    this.$watch(
      () => this.metricData.end,
      () => {
        anime({
          targets: this,
          animatedScore: this.metricData.end?.amount,
          round: 10,
          easing: "linear",
        })
      }
    )
  }

  get isShowAttention() {
    return this.metricData.end ? this.metricData.end.amount < 0.5 : false
  }

  getIcon(superScoreComponent: SuperScoreArea) {
    // FIXME extract this to commons or somewhere more generic? depends on which
    // icons will be used
    switch (superScoreComponent) {
      case SuperScoreArea.AccountBalance:
        return "accountBalance"
      case SuperScoreArea.NominatedBeneficiary:
        return "beneficiary"
      case SuperScoreArea.InvestmentApproach:
        return "investment"
      case SuperScoreArea.LifeInsurance:
        return "insurance"
      case SuperScoreArea.RetirementAdequacy:
        return "retirementAdequacy"
    }
  }

  navigate() {
    // For ripple effect
    setTimeout(async () => this.$router.push(this.to), 100)
  }
}
